import { z } from 'zod';

/**
 * Scheme for GameServiceConfig.
 */
export const GameServiceConfigScheme = z
  .object({
    serviceName: z.string().default(''),
    favoritesRequestEntityName: z.string().default(''),
    suggesterServiceEntityName: z.string().default(''),
    lobbyRouteName: z.string().default(''),
    defaultFeed: z.string().default(''),
    segmentedFeeds: z.array(z.string()).default([])
  })
  .passthrough();

export type GameServiceConfig = z.infer<typeof GameServiceConfigScheme>;
